import { useSelector } from "react-redux";

export default function useFontForGroup() {
    const groupId = useSelector((state: any) => state.app.urlParams.group_id);
    return groupId === "ocQkZY" || groupId === "nhPKxp";
}
